import {ButtonType, ButtonWidget} from '@tableau/widgets';
import React, {useState} from 'react';

import {Messages} from '~src/codegen/Localize';
import {ResultHelper} from '~src/httpClient/utils/ResultHelper';
import {keyHistoryButton} from '~src/kmsInOnline/assets/KMSInOnlineSettingsStyles';
import {IGetSiteEncryptionKeyHistoryResult} from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyHistoryRequest';
import {IGetSiteEncryptionKeyResult} from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyRequest';
import {GetSiteEncryptionKeyHistoryService} from '~src/kmsInOnline/services/GetSiteEncryptionKeyHistoryService';
import hasErrors = ResultHelper.hasErrors;
import {ToasterService, ToastType} from '~commonInfra/services/ToasterService';
import {keyNotFoundError} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';

export const KMS_IN_ONLINE_KEY_HISTORY_DOWNLOAD_BUTTON = 'kms-key-history-download-button';

/**
 * 'Download Log' button - starts a download for a CSV history of all siteEncryptionKey operations
 */
export function DownloadKeyHistoryLogButton(siteEncryptionKey: IGetSiteEncryptionKeyResult) {
  const [downloading, setDownloading] = useState(false);
  return (hasErrors(siteEncryptionKey) && !keyNotFoundError(siteEncryptionKey)) ? null : <ButtonWidget
    buttonType={ButtonType.Outline}
    testId={KMS_IN_ONLINE_KEY_HISTORY_DOWNLOAD_BUTTON}
    onClick={() => handleDownload(downloading, setDownloading)}
    className={keyHistoryButton}
    type='button'
    disabled={downloading}
  > {downloading ? Messages.extractEncryptionTOLKeyHistoryDownloading() : Messages.extractEncryptionTOLKeyHistoryButton()}
  </ButtonWidget>;
}

async function handleDownload(downloading: boolean, setDownloading: (s: boolean) => void) {
  setDownloading(true);
  await GetSiteEncryptionKeyHistoryService.getSiteEncryptionKeyHistory().then(
    (response: IGetSiteEncryptionKeyHistoryResult) => {
      const url = window.URL.createObjectURL(new Blob([response], { type: response?.type }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'site_key_history.csv');
      document.body.appendChild(link);
      link.click();
    }).catch(() => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryptionTOLKeyHistoryDownloadError() });
  });
  setDownloading(false);
}
